import { distanceUnitMap } from '~/constants/distance';
import { weightUnitMap } from '~/constants/weight';

export const weightOptionsBuilder = () =>
  Object.keys(weightUnitMap).map((weightunit) => ({ label: weightunit, value: weightunit }));

export const distanceOptionsBuilder = () =>
  Object.keys(distanceUnitMap).map((distanceUnit) => ({
    label: distanceUnit,
    value: distanceUnit,
  }));
